/* header-h.js
   Keeps the page's --header-h token equal to the theme header's real height.

   Everything that has to clear the sticky header reads that token: the full
   viewport hero (100svh minus the header), the samples stage that pins under
   it, and the product page's tube column. The CSS already carries the measured
   steps (130px, 114px at 768 and under, 92px at 749 and under) so the first
   paint is right without this; the script only corrects the residual, so an
   announcement bar inside the header group, a different logo size on the live
   theme, or a font that lands late never leaves a stage pinned behind the
   header or a strip of page showing under it.

   The header is sticky at top:-1px. The edge the page must clear is where its
   bottom lands once it is pinned, which is its height plus that offset. */
(function () {
  'use strict';
  var root = document.querySelector('.nbnew');
  var hdr = document.querySelector('header.shopify-section.header-section') ||
            document.querySelector('#header-component');
  if (!root || !hdr) return;

  var last = -1;
  function sync() {
    var cs = getComputedStyle(hdr);
    var h = hdr.getBoundingClientRect().height;
    if (!(h > 0)) return;                       // hidden header: keep the CSS steps
    var off = 0;
    if (cs.position === 'sticky' || cs.position === 'fixed') {
      off = parseFloat(cs.top);
      if (isNaN(off)) off = 0;
    }
    var clear = Math.round(h + off);
    if (clear === last) return;
    last = clear;
    root.style.setProperty('--header-h', clear + 'px');
  }

  sync();
  if (window.ResizeObserver) new ResizeObserver(sync).observe(hdr);
  window.addEventListener('resize', sync);
  window.addEventListener('load', sync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
})();
